<div class="main-f-card">
  <ng-container [ngSwitch]="step">
    <ng-container *ngSwitchCase="'CLABE'">
      <div class="grid px-4">
        <div class="col-12 mt-4 mb-2">
          <p>
            Para la solicitud de cualquier producto debes contar con una cuenta validada y conectada con nuestro sistema...
          </p>
        </div>

        <div class="col-12 mt-3 flex flex-column gap-2">
          <label for="clabe">Cuenta CLABE (18 dígitos)*</label>
          <input
            id="clabe"
            type="text"
            pInputText
            [formControl]="clabeControl"
            placeholder="Ingresa tu cuenta CLABE"
            maxlength="18"
          />
          <div class="p-error" *ngIf="clabeControl.invalid && clabeControl.touched">
            <small *ngIf="clabeControl.errors?.['required']">La cuenta CLABE es obligatoria.</small>
            <small *ngIf="clabeControl.errors?.['pattern']">Debe tener exactamente 18 dígitos.</small>
          </div>
        </div>

        <div class="col-12 mb-4 comment-rejected" *ngIf="data.comment && data.comment !== ''">
          Motivo de rechazo: <strong>{{ data.comment }}</strong>
        </div>

        <div class="col-12">
          <div class="message">
            <p-messages [(value)]="responseMessage" [enableService]="showMessage" [closable]="true" [escape]="false"></p-messages>
          </div>
        </div>

        <div class="col-12 button-block-container my-5">
          <button
            pButton
            pRipple
            label="Empezar proceso"
            icon="fa-solid fa-fingerprint p-button-icon-center"
            class="p-button text-center justify-content-center button-block"
            (click)="start()"
          ></button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'OTP'">
      <div class="grid px-4">
        <div class="col-12 mt-4 mb-2">
          <p>Ingresa el microdeposito que recibiste en tu cuenta.</p>
        </div>

        <div class="col-12 mt-3 flex flex-column gap-2">
          <label for="otp">OTP*</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">00.</span>
            <input
              id="otp"
              type="text"
              pInputText
              [formControl]="otpControl"
              placeholder="XX"
              maxlength="2"
            />
          </div>
          <div class="p-error" *ngIf="otpControl.invalid && otpControl.touched">
            <small *ngIf="otpControl.errors?.['required']">El código es obligatorio.</small>
            <small *ngIf="otpControl.errors?.['pattern']">Debe contener 2 dígitos numéricos.</small>
          </div>
        </div>

        <div class="col-12 button-block-container my-2">
          <button
            pButton
            pRipple
            label="Enviar OTP"
            icon="pi pi-check"
            class="p-button"
            (click)="validateOtp()"
            [disabled]="otpControl.invalid"
          ></button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'CONFIRM'">
      <div class="grid px-4">
        <div class="col-12 my-4">
          <p>
            Si has completado el proceso de validación de tu cuenta de nómina, da clic en
            <strong>He concluido el proceso</strong>.
          </p>
        </div>

        <div class="col-12">
          <div class="img img-complete"></div>
        </div>

        <div class="col-12">
          <div class="message">
            <p-messages [(value)]="responseMessage" [enableService]="showMessage" [closable]="true" [escape]="false"></p-messages>
          </div>
        </div>

        <div class="col-12 button-block-container my-5">
          <button
            pButton
            pRipple
            label="He concluido el proceso"
            icon="fa-solid fa-fingerprint p-button-icon-center"
            class="p-button text-center justify-content-center button-block"
            (click)="confirmCompletedProcess()"
          ></button>
        </div>
      </div>
    </ng-container>

  </ng-container>
</div>
